function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { AppContext } from 'context';
import { getLockDuration } from 'helpers/otpErrors';
import Alert from 'components/Alert';
import FormContainerAbstract from 'components/FormContainerAbstract';
import CodeFormPartial from 'components/CodeFormPartial';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import Link from 'components/Link';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
class Mfa extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        if (props.hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { otpStatus } = this.props;
        if (otpStatus && prevProps.otpStatus.lockoutEnd !== otpStatus.lockoutEnd) {
            this.onSetLockout(otpStatus);
        }
    }
    onResendCountdown() {
        const interval = setInterval(()=>{
            let { resendLock } = this.state;
            resendLock--;
            this.setState({
                resendLock
            });
            if (!resendLock) {
                clearInterval(interval);
            }
        }, 1000);
    }
    onResend(evt, isLocked = false) {
        evt.preventDefault();
        evt.stopPropagation();
        if (isLocked || !!this.state.lockoutDuration) {
            return;
        }
        this.props.onResendCode();
        this.setState({
            resendLock: 30
        });
        this.onResendCountdown();
    }
    onSetLockout(otpStatus, isInit = false) {
        const { lockoutEnd } = otpStatus;
        const nowTimestamp = Math.floor(Date.now() / 1000);
        const lockoutDuration = Math.max(lockoutEnd - nowTimestamp, 0);
        if (!isInit) {
            this.setState({
                lockoutDuration
            });
            if (lockoutDuration) {
                this.onUnsetValues([
                    'otp'
                ]);
            }
        }
        return lockoutDuration;
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            this.setState({
                isInProgress: true
            });
            this.props.onSubmit(validatedValues);
        }
    }
    get isDisabled() {
        const otp = get(this.props.formValues, 'values.otp');
        const len = otp && otp.length;
        return len !== constants.OTP_LENGTH || !!this.state.lockoutDuration;
    }
    renderCancelBtn() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: App.messages.buttons.cancel,
            className: "btn--block",
            onClick: this.props.onCancel
        });
    }
    renderSubmitBtn() {
        return /*#__PURE__*/ _jsx(Button, {
            type: "submit",
            styleModifier: "primary",
            labelMessage: messages.buttons.signIn,
            className: "btn--block btn--filled",
            isDisabled: this.isDisabled,
            isInProgress: this.state.isInProgress
        });
    }
    renderActions() {
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-8",
            children: this.state.lockoutDuration ? this.renderCancelBtn() : this.renderSubmitBtn()
        });
    }
    renderLockInfo() {
        if (!this.lockoutDuration) {
            return null;
        }
        const { duration: lockDuration, unit } = getLockDuration(this.state.lockoutDuration);
        const lockUnit = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.timeUnits[unit]));
        return /*#__PURE__*/ _jsx("div", {
            className: "mb-5",
            children: /*#__PURE__*/ _jsx(Alert, {
                type: "error",
                message: App.messages.errors.businessErrors.InvalidOTPEntryLimitLock,
                messageValues: {
                    lockDuration,
                    lockUnit
                }
            })
        });
    }
    renderResendInfo() {
        const { resendLock } = this.state;
        const message = messages.buttons[resendLock ? 'resendOtpLock' : 'resendOtp'];
        return /*#__PURE__*/ _jsxs("p", {
            className: "text--small text--light text--center",
            children: [
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.resendOtp)),
                        " "
                    ]
                }),
                /*#__PURE__*/ _jsxs(Link, {
                    to: "",
                    type: "button",
                    className: "text--primary",
                    onClick: (evt)=>this.onResend(evt, !!resendLock),
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                            values: {
                                resendLock
                            }
                        })),
                        "."
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderLockInfo(),
                /*#__PURE__*/ _jsxs(Form, {
                    className: "pt-5",
                    onSubmit: ()=>this.onSubmit(),
                    children: [
                        /*#__PURE__*/ _jsx(CodeFormPartial, {
                            id: "otp",
                            codeLength: constants.OTP_LENGTH,
                            className: "mb-3",
                            isDisabled: !!this.state.lockoutDuration,
                            onSetFormValue: this.props.onSetFormValue
                        }),
                        this.renderResendInfo(),
                        this.renderActions()
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.lockoutDuration = this.onSetLockout(props.otpStatus, true);
        this.state = {
            resendLock: 0,
            lockoutDuration: this.lockoutDuration,
            isInProgress: false
        };
        this.validatorRules = {
            otp: `required, length ${constants.OTP_LENGTH}`
        };
    }
}
_define_property(Mfa, "contextType", AppContext);
_define_property(Mfa, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit actions
    onSetFormValue: PropTypes.func,
    onCancel: PropTypes.func,
    // Explicit props
    otpStatus: shapes.otpStatus,
    isDisabled: PropTypes.bool,
    // Implicit props
    hasErrors: PropTypes.bool,
    // Implicit actions
    onSendCode: PropTypes.func
}));
const mapStateToProps = (state)=>({
        otpStatus: selectors.otpStatus(state),
        identityProviders: selectors.identityProviders(state),
        hasErrors: selectors.hasOtpErrors(state),
        formValues: App.selectors.formSelector(constants.SIGN_IN_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.SIGN_IN_FORM;
    return {
        onResendCode: ()=>dispatch(actions.resendOtp()),
        onSubmit: ({ otp })=>dispatch(actions.verifyOtp(otp)),
        onUnsetFormValues: (ids)=>dispatch(App.actions.unsetFormValues(formName, ids)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedMfa = connect(mapStateToProps, mapDispatchToProps)(Mfa);
export default ConnectedMfa;
